<div id="product" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/clientes/consulta'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div 
                    class="product-image mr-8 mr-sm-16" 
                    [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}"
                >
                    <mat-icon class="logo-icon s-32 mr-16">
						account_box
					</mat-icon>
                </div>

                <div 
                    fxLayout="column" 
                    fxLayoutAlign="start start"
                    [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}"
                >
                    <div class="h2" *ngIf="data != null && data != undefined">
                        Dados do Cliente - {{ nome.value }}
                    </div>
                    <div class="h2" *ngIf="data == null && data == undefined">
                        Novo Cliente
                    </div>
                </div>               
            </div>
            <!-- / APP TITLE -->

            <div fxLayout="row" >
                <button 
                    mat-mini-fab
                    matTooltip = "Cadastrar"
                    color="green"
                    class="save-product-button"
                    [disabled]="isInvalidForm()"
                    *ngIf="data == null && data == undefined" 
                    (click)="salvar()">
                    <mat-icon>save</mat-icon>
                </button>

                <button 
                    mat-mini-fab
                    matTooltip = "Salvar"
                    color="green"
                    class="save-product-button"
                    [disabled]="isInvalidForm()"
                    *ngIf="data != null && data != undefined" 
                    (click)="salvar()">
                    <mat-icon>save</mat-icon>
                </button>
            </div>
            
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content">

                <form name="productForm" class="product w-100-p" fxLayout="column" fxFlex>

                    <mat-tab-group (selectedTabChange)="onLinkClick($event)">

                        <mat-tab label="Info. Cadastrais">
                            <ng-template matTabContent>
                                <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="23">
                                            <mat-label>Conta Investimento BTG</mat-label>
                                            <input 
                                                matInput 
                                                type="number"
                                                [formControl]="numero_xp" 
                                                placeholder="Conta Investimento BTG" 
                                                name="numero_xp"
                                                maxlength="2"
                                                (change)="verificaContaCliente()"
                                            >   
                                            <mat-error *ngIf="numero_xp.hasError('required')"> Este campo é obrigatório.</mat-error>    
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="15">
                                            <mat-label>Conta Banking BTG</mat-label>
                                            <input 
                                                matInput 
                                                type="number"
                                                placeholder="Conta banking BTG" 
                                                [formControl]="conta_antiga" 
                                                name="conta_antiga"                                             
                                                maxlength="20"
                                            >
                                            <mat-error *ngIf="conta_antiga.invalid">{{getErrorNumeroXPMessage()}}</mat-error>
                                        </mat-form-field>
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="8">
                                            <mat-label>Digito Banking BTG</mat-label>
                                            <input 
                                                matInput 
                                                type="number"
                                                placeholder="X" 
                                                [formControl]="digito_conta_antiga" 
                                                name="digito_conta_antiga"
                                                maxlength="2"
                                            >                                        
                                        </mat-form-field>
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="53">
                                            <mat-label>Tipo de Cliente</mat-label>
                                            <mat-select required [(ngModel)]="model.tipo_pessoa" name="tipo_pessoa" (selectionChange)="changeTipoCliente()">
                                                <mat-option value="PF">Pessoa Física</mat-option> 
                                                <mat-option value="PJ">Pessoa Jurídica</mat-option>
                                            </mat-select>
                                        </mat-form-field>
    
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="79">
                                            <mat-label>Nome</mat-label>
                                            <input 
                                                matInput 
                                                placeholder="Nome" 
                                                [formControl]="nome" 
                                                name="nome" 
                                                required 
                                                maxlength="255"
                                                style="text-transform: uppercase"
                                            >
                                            <mat-error *ngIf="nome.invalid">{{getErrorNomeFantasiaMessage()}}</mat-error>
                                        </mat-form-field>
                                        
                                        <mat-form-field 
                                            appearance="outline" 
                                            floatLabel="always" 
                                            fxFlex="19" 
                                            *ngIf="isCnpj"
                                        >
                                            <mat-label>CNPJ</mat-label>
                                            <input 
                                                matInput 
                                                placeholder="CNPJ" 
                                                [formControl]="cnpj" 
                                                name="cnpj" 
                                                maxlength="20" 
                                                mask="00.000.000/0000-00"
                                            >
                                        </mat-form-field>
                                    
                                        <mat-form-field 
                                            appearance="outline" 
                                            floatLabel="always" 
                                            fxFlex="19" 
                                            *ngIf="isCpf"
                                        >
                                            <mat-label>CPF</mat-label>
                                            <input 
                                                matInput 
                                                placeholder="CPF" 
                                                [formControl]="cpf" 
                                                name="cpf" 
                                                maxlength="15" 
                                                mask="000.000.000-00"
                                            >
                                        </mat-form-field>
                                    </div>
                                    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" *ngIf="isCnpj">
                                            <mat-label>Razão Social</mat-label>
                                            <input matInput placeholder="Razão Social" [formControl]="razao_social" name="razao_social" required maxlength="255">
                                            <mat-error *ngIf="razao_social.invalid">{{getErrorRazaoSocialMessage()}}</mat-error>
                                        </mat-form-field>
                                    </div>
    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Data de Nascimento</mat-label>
                                            <input matInput [matDatepicker]="picker" [formControl]="data_nascimento" name="data_nascimento" placeholder="Data de Nascimento">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Telefone</mat-label>
                                            <input 
                                                matInput 
                                                placeholder="Telefone" 
                                                [formControl]="telefone" 
                                                [required] = "!isConditionIsTrue"
                                                name="telefone" 
                                                mask="(00) 00000-0000">
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>E-mail</mat-label>
                                            <input matInput placeholder="E-mail" [formControl]="email" maxlength="255" name="email">
                                            <mat-error *ngIf="email.invalid">{{getErrorEmailMessage()}}</mat-error>
                                        </mat-form-field>
                                    </div>
    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="30">
                                            <mat-label>Sexo</mat-label>
                                            <mat-select
                                                [(value)]="model.sexo"
                                                [formControl]="sexo"                                             
                                            >
                                                <mat-option value="">SELECIONE</mat-option>
                                                <mat-option [value]="'M'">Masculino</mat-option>
                                                <mat-option [value]="'F'">Feminino</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="30">
                                            <mat-label>Estado Civil</mat-label>
                                            <mat-select
                                                [(value)]="model.estado_civil_id"
                                                [formControl]="estado_civil_id"
                                            >
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let estadoCivil of listEstadoCivil" [value]="estadoCivil.id">{{estadoCivil.nome}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerEstadoCivil"></mat-spinner>
                                        </mat-form-field>
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Profissão</mat-label>
                                            <mat-select 
                                                placeholder="Profissão"
                                                [(value)]="model.profissao_id" 
                                                [formControl]="profissao_id"
                                                name="profissao_id">
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let profissao of listProfissao" [value]="profissao.id">{{profissao.nome}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerProfissao"></mat-spinner>
                                        </mat-form-field>
                                        
                                    </div>                                
                                    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Suitability</mat-label>
                                            <mat-select
                                                [(value)]="model.perfil_id" 
                                                [formControl]="perfil_id"
                                                name="perfil_id" >
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let perfil of listPerfil" [value]="perfil.id">{{perfil.nome}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerPerfil"></mat-spinner>										
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Situação Tributária</mat-label>
                                            <mat-select 
                                                placeholder="Situação Tributária"
                                                [(value)]="model.tipo_situacao_tributaria" 
                                                [formControl]="tipo_situacao_tributaria"                                            
                                                name="tipo_situacao_tributaria" >
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let situacao of listSituacaoTributaria" [value]="situacao.id">{{situacao.nome}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerSituacao"></mat-spinner>										
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Assessor</mat-label>                                        
                                            <mat-select 
                                                placeholder="Assessor"
                                                [(value)]="model.assessor_id" 
                                                [formControl]="assessor_id"
                                                required 
                                                name="assessor_id">
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                                            <mat-error *ngIf="assessor_id.invalid">{{getErrorAssessorMessage()}}</mat-error>
                                        </mat-form-field>
                                    </div>
                                    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Cliente Prospect?</mat-label>
                                            <mat-select 
                                                (click)="setRequired()"
                                                [(ngModel)]="model.cliente_prosp" 
                                                [formControl]="cliente_prosp" 
                                                name="cliente_prosp">
                                                <mat-option value="true">SIM</mat-option> 
                                                <mat-option value="false">NÃO</mat-option>
                                            </mat-select>
                                        </mat-form-field>   

                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Origem do Cliente</mat-label>
                                            <mat-select 
                                                placeholder="Origem"
                                                [(value)]="model.origem_cliente_id" 
                                                [formControl]="origem_cliente_id"
                                                name="origem_cliente_id" 
                                            >
                                                    <mat-option value="">Selecione...</mat-option>
                                                    <mat-option *ngFor="let origem of listOrigem" [value]="origem.id">{{origem.nome}}</mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerOrigem"></mat-spinner>							
                                        </mat-form-field>
    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Classificação do Cliente</mat-label>
                                            <mat-select
                                                placeholder="Classificação"
                                                [(value)]="model.primeiro_contato_id"
                                                [formControl]="primeiro_contato_id"
                                                name="primeiro_contato_id"
                                            >
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option 
                                                    *ngFor="let classificao of listPrimeiroContato" 
                                                    [value]="classificao.id"
                                                >
                                                    {{classificao.nome}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-spinner diameter="20" *ngIf="loadingSpinnerPrimeiro"></mat-spinner>							
                                        </mat-form-field>
                                        
                                        
        
                                    </div>
                                </div>
                            </ng-template>
                        </mat-tab>

                        <mat-tab label="Endereço/Contato" >
                            <ng-template matTabContent>
                                <div class="tab-content p-24" fusePerfectScrollbar>

                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="20">
                                            <mat-label>CEP</mat-label>
                                            <input type="number" matInput placeholder="CEP" [formControl]="cep" name="cep" (blur)="getEnderecoByCep()" maxlength="255">
                                        </mat-form-field>
                                        
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="10">
                                                <mat-label>Tipo Endereço</mat-label>
                                                <mat-select placeholder="Tipo Endereço"
                                                            [(value)]="model.tipo_endereco" [formControl]="tipo_endereco"
                                                            required name="tipo_endereco" >
                                                    <mat-option value="">Selecione...</mat-option>
                                                    <mat-option value="R">Residencial</mat-option>
                                                    <mat-option value="C">Comecial</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Estado</mat-label>
                                            <mat-select placeholder="Estado" (selectionChange)="getAllCidades($event)"
                                                        [(value)]="model.estado_id" 
                                                        [formControl]="estado_id" 
                                                        [disabled]="isDisabledEstado()"
                                                        name="estado_id" >
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let estado of listEstados" [value]="estado.id">{{estado.nome}}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="estado_id.invalid">{{getErrorEstadoMessage()}}</mat-error>
                                        </mat-form-field>
                                    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Cidade</mat-label>
                                            <mat-select placeholder="Cidade" [(value)]="model.cidade_id" [formControl]="cidade_id"
                                                        [disabled]="isDisabledCidade()" name="cidade_id">
                                                <mat-option value="">Selecione...</mat-option>
                                                <mat-option *ngFor="let cidade of listCidades" [value]="cidade.id">{{cidade.nome}}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="cidade_id.invalid">{{getErrorCidadeMessage()}}</mat-error>
                                        </mat-form-field>
                                    </div>
                                    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Bairro</mat-label>
                                            <input matInput placeholder="Bairro" [formControl]="bairro" maxlength="255" name="bairro">
                                            <mat-error *ngIf="bairro.invalid">{{getErrorBairroMessage()}}</mat-error>
                                        </mat-form-field>
                                    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Endereço</mat-label>
                                            <input matInput placeholder="Endereço" [formControl]="endereco" maxlength="255" name="endereco">
                                            <mat-error *ngIf="endereco.invalid">{{getErrorEnderecoMessage()}}</mat-error>
                                        </mat-form-field>
                                    
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="30">
                                            <mat-label>Número</mat-label>
                                            <input matInput placeholder="Número" [formControl]="numero" maxlength="255" name="numero">
                                            <mat-error *ngIf="numero.invalid">{{getErrorNumeroMessage()}}</mat-error>
                                        </mat-form-field>								
                                    </div>   
    
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                                            <mat-label>Complemento</mat-label>
                                            <input 
                                                matInput 
                                                placeholder="Complemento" 
                                                [formControl]="complemento" 
                                                maxlength="255" 
                                                name="complemento"
                                            >
                                            
                                        </mat-form-field>
                                    </div>                             
                                </div>
                            </ng-template>
						</mat-tab>

                        <mat-tab label="Produtos" *ngIf="existeCliente" style="background-color: #eee;">
                            <ng-template matTabContent>
                                <app-cliente-coe [cliente_id]="data"></app-cliente-coe> 
                                <app-cliente-renda-fixa [cliente_id]="data" style="margin-top: 20px;"></app-cliente-renda-fixa>
                                <app-cliente-previdencia [cliente_id]="data" style="margin-top: 20px;"></app-cliente-previdencia>
                                <app-cliente-fundo-investimento [cliente_id]="data" style="margin-top: 20px;"></app-cliente-fundo-investimento>
                                <app-cliente-renda-variavel [cliente_id]="data" style="margin-top: 20px;"></app-cliente-renda-variavel>
                            </ng-template>                           
                        </mat-tab>   

                        <mat-tab label="Histórico de Relacionamento" *ngIf="existeCliente">
                            <ng-template matTabContent>
                                <mat-card>
                                    <mat-card-header style="margin-bottom: 20px">
                                        <mat-card-title>Histórico de Relacionamento</mat-card-title>
    
                                        <button 
                                            mat-mini-fab                                        
                                            *ngIf="data != null && data != undefined" 
                                            matTooltip="Adicionar novo Relacionamento"
                                            (click)="cadastrarRelacionamento()">
                                            <mat-icon>add</mat-icon>
                                        </button>
    
                                        <button 
                                            mat-mini-fab
                                            style=" margin-left: 10px"
                                            *ngIf="data != null && data != undefined" 
                                            matTooltip="Filtrar"
                                            (click)="filtrarHistoricoRelacionamento()">
                                            <mat-icon>search</mat-icon>
                                        </button>
    
                                    </mat-card-header>
                                   
                                    <mat-card-content>
                                        <ngx-datatable 
                                            #tableRelacionamento 
                                            class='material striped' 
                                            [loadingIndicator]="loadingRelacionamento"
                                            [columns]="columns" 
                                            [columnMode]="'force'" 
                                            [headerHeight]="50"                       
                                            [footerHeight]="50" 
                                            [rowHeight]="'auto'" 
                                            [rows]='rowsRelacionamento'
                                            [limit]="params.per_page"
                                        >
    
                                            <ngx-datatable-column name="Data" prop="created_at" [sortable]="false" [width]="80">
                                                <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                                                    {{created_at | date:'dd/MM/yyyy'}}
                                                </ng-template>
                                            </ngx-datatable-column>   
                                                                        
                                            <ngx-datatable-column name="Ação" prop="acao" [sortable]="false">
                                                <ng-template let-rowIndex="rowIndex" let-acao="value" ngx-datatable-cell-template>
                                                    {{acao.nome}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Observação" prop="observacao" [sortable]="false" [width]="400">
                                                <ng-template let-rowIndex="rowIndex" let-observacao="value" ngx-datatable-cell-template>
                                                    {{observacao}}
                                                </ng-template>
                                            </ngx-datatable-column>
    
                                            <ngx-datatable-column name="Assessor" prop="usuario" [sortable]="false">
                                                <ng-template let-rowIndex="rowIndex" let-usuario="value" ngx-datatable-cell-template>
                                                    {{usuario.name}}
                                                </ng-template>
                                            </ngx-datatable-column>
     
                                            <ngx-datatable-column name="Ações" prop="id" [sortable]="false" [width]="80" *ngIf='user.role_id == 2 || user.role_id == 4 || user.role_id == 7'>
                                                <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                                                    <button mat-icon-button matTooltip="Alterar Relacionamento" (click)="alterarRelacionamento(id)">
                                                        <mat-icon aria-label="Editar Relacionamento">edit</mat-icon>
                                                    </button>
                                                </ng-template>
                                            </ngx-datatable-column>
    
                                        </ngx-datatable>
                            
                                        <div style="padding: 5px 10px">
                                            <mat-paginator 
                                                #paginatorRelacionamento 
                                                [length]="lengthRelacionamento"
                                                [pageSize]="pageSizeRelacionameto"
                                                [pageSizeOptions]="pageSizeOptionsRelacionamento"
                                                (page)="pageEventRelacionamento($event)">
                                            </mat-paginator>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </ng-template>
                        </mat-tab>


                        <mat-tab label="Carteira Crédito/Câmbio/Consórcio" *ngIf="existeCliente">
                            <mat-card>
                                <mat-card-header style="margin-bottom: 20px">
                                    <mat-card-title>Carteira Crédito/Câmbio/Consórcio</mat-card-title>

                                    <button 
                                        mat-mini-fab                                        
                                        *ngIf="data != null && data != undefined" 
                                        matTooltip="Adicionar nova Carteira"
                                        (click)="openCadastroCarteiraConsorcio()">
                                        <mat-icon>add</mat-icon>
                                    </button>

                                    <!--<button 
                                        mat-mini-fab
                                        style=" margin-left: 10px"
                                        *ngIf="data != null && data != undefined" 
                                        matTooltip="Filtrar"
                                        (click)="filtrarHistoricoRelacionamento()">
                                        <mat-icon>search</mat-icon>
                                    </button>-->

                                </mat-card-header>
                               
                                <mat-card-content>
                                    <!-- todo: removido (sort)="onSort($event)" -->
                                    <ngx-datatable 
                                        #tableRelacionamento 
                                        class='material striped' 
                                        [loadingIndicator]="loadingListaCarteiraConsorcio"
                                        [columns]="columns" 
                                        [columnMode]="'force'" 
                                        [headerHeight]="50"                       
                                        [footerHeight]="50" 
                                        [rowHeight]="'auto'" 
                                        [rows]='rowsCarteiraConsorcio'
                                        [limit]="params.per_page"
                                        >

                                        <ngx-datatable-column name="Tipo" prop="tipo_consorcio" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-tipo_consorcio="value" ngx-datatable-cell-template>
                                                {{tipo_consorcio?.nome}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Empresa" prop="empresa_consorcio" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-empresa_consorcio="value" ngx-datatable-cell-template>
                                                {{ empresa_consorcio?.nome }}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Valor Contratado" prop="valor_contratado" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-valor_contratado="value" ngx-datatable-cell-template>
                                                {{valor_contratado | number : '1.2-2'}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Grupo" prop="grupo" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-grupo="value" ngx-datatable-cell-template>
                                                {{grupo}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Cota" prop="cota" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-cota="value" ngx-datatable-cell-template>
                                                {{cota}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Ações" prop="id" [sortable]="false" *ngIf='user.role_id == 2 || user.role_id == 4 || user.role_id == 7'>
                                            <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                                                <button mat-icon-button matTooltip="Visualizar Carteira" (click)="openVisualizarCarteiraConsorcio(id)">
                                                    <mat-icon aria-label="Visualizar Carteira">search</mat-icon>
                                                </button>
                                            
                                                <button mat-icon-button matTooltip="Alterar Carteira" (click)="openAlterarCarteiraConsorcio(id)">
                                                    <mat-icon aria-label="Alterar Carteira">edit</mat-icon>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>

                                    </ngx-datatable>
                        
                                    <div style="padding: 5px 10px">
                                        <mat-paginator 
                                            #paginatorClienteCarteiraConsorcio
                                            [length]="lengthCarteiraConsorcio"
                                            [pageSize]="pageSizeCarteiraConsorcio"
                                            [pageSizeOptions]="pageSizeOptionsCarteiraConsorcio"
                                            (page)="pageEventCarteiraConsorcio($event)">
                                        </mat-paginator>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>

                    </mat-tab-group>
                </form>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>